var map = {
	"./0.png": [
		6496,
		414
	],
	"./1.png": [
		1079,
		79
	],
	"./2.png": [
		9534,
		534
	],
	"./3.png": [
		8614,
		614
	],
	"./4.png": [
		7322,
		322
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3414;
module.exports = webpackAsyncContext;